















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { VideoProvider, detectVideoProvider } from '@front-app/components/video/util';
import YoutubeEmbed from './YoutubeEmbed.vue';
import VimeoEmbed from './VimeoEmbed.vue';

const AUTO_DETECT = 'auto-detect';

export default defineComponent({
	components: {
		YoutubeEmbed,
		VimeoEmbed,
	},
	props: {
		// Auto-detect only available for URL video IDs
		videoProvider: {
			type: String as PropType<VideoProvider | typeof AUTO_DETECT>,
			default: AUTO_DETECT,
		},
		videoId: {
			type: String,
			required: true,
		},
		autoplay: Boolean,
	},
	setup(props) {
		const detectedProvider = computed(() => (props.videoProvider === AUTO_DETECT ? detectVideoProvider(props.videoId) : props.videoProvider));
		return {
			VideoProvider,
			detectedProvider,
		};
	},
});
